import React, { type FunctionComponent } from 'react'
import { HeroBannersList } from 'domains/merchandising/components/hero-banners-list/HeroBannersList'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from 'legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from 'legacy/dash-components/dash-redirect/DashRedirect'
import { HeroBannerCreate } from 'domains/merchandising/components/hero-banner-create/HeroBannerCreate'
import { HeroBannerDetails } from 'domains/merchandising/components/hero-banner-details/HeroBannerDetails'
import { HeroBannerUpdate } from 'domains/merchandising/components/hero-banner-update/HeroBannerUpdate'

export const MerchandisingSection: FunctionComponent = () => (
  <DashSwitch>
    <DashRoute exact route="merchandising-hero-banners-list" component={HeroBannersList} />

    <DashRoute exact route="merchandising-hero-banners-create" component={HeroBannerCreate} />

    <DashRoute exact route="merchandising-hero-banners-edit" component={HeroBannerUpdate} />

    <DashRoute exact route="merchandising-hero-banners-details" component={HeroBannerDetails} />

    <DashRedirect toRoute="merchandising-hero-banners-list" />
  </DashSwitch>
)
